// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * LCC API
 * API for the LCC backend
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * An input or output argument of a callable method
 * @export
 * @interface MethodArgument
 */
export interface MethodArgument {
    /**
     * 
     * @type {string}
     * @memberof MethodArgument
     */
    name: string;
    /**
     * OPC UA DataType name (e.g. Double, String, Boolean)
     * @type {string}
     * @memberof MethodArgument
     */
    dataType: string;
    /**
     * 
     * @type {string}
     * @memberof MethodArgument
     */
    description?: string;
}

/**
 * Check if a given object implements the MethodArgument interface.
 */
export function instanceOfMethodArgument(value: object): value is MethodArgument {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('dataType' in value) || value['dataType'] === undefined) return false;
    return true;
}

export function MethodArgumentFromJSON(json: any): MethodArgument {
    return MethodArgumentFromJSONTyped(json, false);
}

export function MethodArgumentFromJSONTyped(json: any, ignoreDiscriminator: boolean): MethodArgument {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'dataType': json['dataType'],
        'description': json['description'] == null ? undefined : json['description'],
    };
}

export function MethodArgumentToJSON(json: any): MethodArgument {
    return MethodArgumentToJSONTyped(json, false);
}

export function MethodArgumentToJSONTyped(value?: MethodArgument | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'dataType': value['dataType'],
        'description': value['description'],
    };
}

